"use client";

import { useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import "./SearchBar.css";

const SearchBar = ({ onSearch }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const inputRef = useRef(null);

    // Récupérer la valeur de `search` depuis l'URL
    const searchTerm = searchParams.get("search") || "";

    const handleSubmit = (e) => {
        e.preventDefault();
        const params = new URLSearchParams(searchParams);
        params.set("page", 1);
        params.set("search", searchTerm);
        setSearchParams(params);
        if (onSearch) {
            onSearch(searchTerm);
        }
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        const params = new URLSearchParams(searchParams);
        params.set("search", value);
        params.set("page", 1);
        setSearchParams(params);
    };

    return (
        <div className="search-container">
            <form onSubmit={handleSubmit} className="search-bar-container">
                <div className="search-input-wrapper">
                    <input
                        ref={inputRef}
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleInputChange}
                        placeholder="Recherchez par espèces, catégorie ou fournisseur"
                        className="search-input"
                        id="search-input1"
                        autoComplete="off"
                    />
                    {isLoading && <span className="loading-spinner">⏳</span>}
                </div>
                <button type="submit" className="search-button">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginRight: "8px" }}
                    >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                    Rechercher
                </button>
            </form>
        </div>
    );
};

export default SearchBar;
